import { render, staticRenderFns } from "./addUpdateWhallet.vue?vue&type=template&id=13a663f1"
import script from "./addUpdateWhallet.vue?vue&type=script&lang=js"
export * from "./addUpdateWhallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports